var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"fixed-bottom footer",attrs:{"dark":"","absolute":"","color":"#334455"}},[_c('div',{staticClass:"footer"},[_vm._v("\n    "+_vm._s(_vm.caption)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }